module.exports = "<flash-messages></flash-messages>\r\n<router-outlet></router-outlet>\r\n"


//////////////////
// WEBPACK FOOTER
// G:/3csoft/client-final/src/app/layout/layouts/nomenu.template.html
// module id = ../../../../../src/app/layout/layouts/nomenu.template.html
// module chunks = main